module.exports = __webpack_public_path__ + "static/disabled-access-coach-yutong-interior-79584f84ea6ba88449f08ea2f1000f46.jpg";